import React, { useEffect, useState } from 'react';
import { dismissAnnouncement } from 'services';
import './AnnouncementsBar.scss';

const AnnouncementsBar = ({ items = [] }) => {
  const [hidden, setHidden] = useState(false);
  const [visibleItems, setVisibleItems] = useState(items || []);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    setVisibleItems(items || []);
    setCurrentIndex(0);
  }, [items]);

  // Auto-rotate announcements
  useEffect(() => {
    if (paused || !Array.isArray(visibleItems) || visibleItems.length <= 1) return undefined;
    const id = setInterval(() => setCurrentIndex((i) => (i + 1) % visibleItems.length), 6000);
    return () => clearInterval(id);
  }, [paused, visibleItems.length]);

  if (hidden || !visibleItems?.length) return null;
  const isCarousel = Array.isArray(visibleItems) && visibleItems.length > 1;

  const active = visibleItems[Math.max(0, currentIndex % visibleItems.length)] || {};
  const title = active?.title;
  const category = active?.category;
  const description = active?.description;

  const handleDismiss = async () => {
    try {
      if (active?.announcement_id) await dismissAnnouncement(active.announcement_id);
    } catch (_) {
    } finally {
      setVisibleItems((prev) => {
        const next = prev.filter((_, idx) => idx !== currentIndex);
        if (next.length === 0) setHidden(true);
        setCurrentIndex((i) => (next.length > 0 ? i % next.length : 0));
        return next;
      });
    }
  };

  return (
    <div
      className="announcements-bar"
      onMouseEnter={isCarousel ? () => setPaused(true) : undefined}
      onMouseLeave={isCarousel ? () => setPaused(false) : undefined}
      aria-live="polite"
    >
      <div className="">
        <div className="announcements-header">
          <div className="announcements-left">
            <i className="fas fa-bullhorn announcements-icon" />
            <p className="announcements-title">{title}</p>
            <span className="new-feature-tag announcements-tag">{String(category).toUpperCase()}</span>
          </div>
          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            {isCarousel && (
              <div className="announcements-dots">
                {visibleItems.map((_, idx) => (
                  <span
                    key={`dot-${idx}`}
                    onClick={() => setCurrentIndex(idx)}
                    className={`announcements-dot ${idx === currentIndex ? 'active' : ''}`}
                  />
                ))}
              </div>
            )}
            <i className="bi bi-x-lg announcements-close" onClick={handleDismiss} />
          </div>
        </div>
      </div>
      <div className="announcements-desc">{description}</div>
    </div>
  );
};

export default AnnouncementsBar;
